import env from './env';
import * as Sentry from "@sentry/browser";
import Locale from './vue-i18n-locales.generated';

const $t = (item) =>
  localStorage.getItem('language')
    ? Locale[localStorage.getItem('language')][item]
    : Locale['ua'][item];

export default {
  // Function for making unique arrays of objects
  getUnique(arr, comp) {
    const unique = arr
      .map((e) => e[comp])

      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  },

  // Function for making one object from two (special for answers pair options)
  getOneAnswerPair(arr) {
    const main = [];
    const secondary = [];
    const secondaryBusyIds = [];

    arr.forEach((item) => {
      if (item === null || item === undefined) return;
      item.is_main ? main.push(item) : secondary.push(item);
    });

    const isStudent = main.every((item) => item.pair === null);

    main.forEach((m, mIndex) => {
      secondary.forEach((s, sIndex) => {
        if (m.id === s.pair) {
          m.photo = s.photo;
          m.photo_desc = s.photo_desc;
          m.secondary_option_text = s.text;
          m.pairId = +s.id;
          m.isSingleAnswer = false;
          secondaryBusyIds.push(s.id);
        }

        // for student mix answers
        if (isStudent && mIndex === sIndex) {
          m.photo = s.photo;
          m.photo_desc = s.photo_desc;
          m.secondary_option_text = s.text;
          m.pairId = +s.id;
          secondaryBusyIds.push(s.id);
        }
      });
    });

    if (main.length === secondary.length) return main;

    const idNotBusy = (item) => !secondaryBusyIds.includes(item.id);
    const singleVariants = secondary.filter(idNotBusy);

    singleVariants.forEach((item) => {
      const locItem = { ...item };

      locItem.secondary_option_text = item.text;
      locItem.text = '';
      locItem.pairId = isStudent ? item.id : null;
      locItem.isSingleOption = true;

      main.push(locItem);
    });

    return main;
  },

  unescape(text) {
    if (text) {
      let decodeHTML = (html) => {
        let txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
      };
      return decodeHTML(text);
    }
  },

  getMathElements() {
    return [
      'math',
      'maction',
      'maligngroup',
      'malignmark',
      'menclose',
      'merror',
      'mfenced',
      'mfrac',
      'mglyph',
      'mi',
      'mlabeledtr',
      'mlongdiv',
      'mmultiscripts',
      'mn',
      'mo',
      'mover',
      'mpadded',
      'mphantom',
      'mroot',
      'mrow',
      'ms',
      'mscarries',
      'mscarry',
      'msgroup',
      'msline',
      'mspace',
      'msqrt',
      'msrow',
      'mstack',
      'mstyle',
      'msub',
      'msup',
      'msubsup',
      'mtable',
      'mtd',
      'mtext',
      'mtr',
      'munder',
      'munderover',
      'semantics',
      'annotation',
      'annotation-xml',
    ];
  },

  // return ckeditor configufaration
  getCkeditorCommonConfig(height_new=null) {
    let height = 'calc(80vh - 225px)';
    if(height_new)height=height_new;
    return {
      font_names:
        'Century Schoolbook; Arial/Arial, Helvetica, sans-serif;Comic Sans MS/Comic Sans MS, ' +
        'cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;' +
        'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, ' +
        'sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, ' +
        'sans-serif;Verdana/Verdana, Geneva, sans-serif',
      defaultLanguage: 'ua',
      language: localStorage.getItem('language')
        ? localStorage.getItem('language')
        : 'ua',
      mathJaxLib:
        'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
      mathJaxClass: 'ckeditor-formulas',
      extraPlugins:
        'uploadimage,image2,mathjax,html5video,stylescombo,html5audio,youtube,imagesfromword,textindent,ckeditor_wiris,fakeobjects,dialog,dialogui,iframe',
      extraAllowedContent:
        this.getMathElements().join(' ') +
        '(*)[*]{*};img[data-mathml,data-custom-editor,role](Wirisformula)',
      height: '400px',
      youtube_width: '640',
      youtube_height: '480',
      youtube_responsive: false,
      youtube_related: true,
      youtube_privacy: false,
      youtube_autoplay: false,
      youtube_controls: true,
      youtube_disabled_fields: ['txtEmbed', 'chkAutoplay'],
      uploadUrl: env.api_url + 'ckeditor_image_upload/?lang=ru&format=json',
      filebrowserUploadUrl:
      env.api_url + 'ckeditor_image_upload/?lang=ru&format=json',
      //fontSize_sizes: '14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;28/28px;36/36px',
      //stylesSet: 'my_styles',
      stylesSet: 'my_styles:/static/front-end/public/assets/js/ckeditor/mystyles.js',
      //stylesSet: 'my_styles:/static/assets/js/ckeditor_4.13.0_acbd9c4b73ee/ckeditor/mystyles.js',

      //CKEDITOR.plugins.addExternal('ckeditor_wiris', '/static/assets/js/ckeditor/', 'mystyles.js');
      toolbar: [
          {
            name: 'clipboard',
            items: ['Undo', 'Redo', 'Cut', 'Copy', 'Paste', 'PasteText'],
          },
          {
            name: 'ckeditor_wiris',
            items: [
              'ckeditor_wiris_formulaEditor',
              'ckeditor_wiris_formulaEditorChemistry',
            ],
          },
          {
            name: 'math',
            items: ['Mathjax', 'Table', 'HorizontalRule', 'SpecialChar'],
          },
          {
            name: 'link',
            items: ['Link', 'Unlink', 'Image', 'Html5video', 'Html5audio', 'Youtube', 'Iframe'],
          },
          {
            name: 'basicstyles',
            items: [
              'Styles', 'CreateDiv', 'Font', 'FontSize', 'RemoveFormat', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'
            ],
          },
          {
            name: 'color',
            items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'TextColor', 'BGColor'],
          },
          {
            name: 'paragraph',
            items: [
              'NumberedList', 'BulletedList',  'PageBreak', 'BidiLtr', 'BidiRtl'
            ],
          },
          {
            name: 'others',
            items: ['Maximize', 'Source', 'ShowBlocks'],
          },
        ],
    };
  },
  getCkeditorStudentConfig() {
    return {
      width: '100%',
      height: 'calc(80vh - 185px)',
      toolbar: [],
      font_names:
        'Century Schoolbook; Arial/Arial, Helvetica, sans-serif;Comic Sans MS/Comic Sans MS, ' +
        'cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;' +
        'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, ' +
        'sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, ' +
        'sans-serif;Verdana/Verdana, Geneva, sans-serif',
      defaultLanguage: 'ua',
      language: localStorage.getItem('language')
        ? localStorage.getItem('language')
        : 'ua',
      mathJaxLib:
        'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
      mathJaxClass: 'ckeditor-formulas',
      extraPlugins:
        'uploadimage,image2,mathjax,html5video,html5audio,youtube,imagesfromword,ckeditor_wiris',
      extraAllowedContent:
        this.getMathElements().join(' ') +
        '(*)[*]{*};img[data-mathml,data-custom-editor,role](Wirisformula)',
      youtube_width: '640',
      youtube_height: '480',
      youtube_responsive: false,
      youtube_related: true,
      youtube_privacy: false,
      youtube_autoplay: false,
      youtube_controls: true,
      youtube_disabled_fields: ['txtEmbed', 'chkAutoplay'],
      uploadUrl: env.api_url + 'ckeditor_image_upload/?lang=ru&format=json',
      filebrowserUploadUrl:
        env.api_url + 'ckeditor_image_upload/?lang=ru&format=json',
    };
  },
  getCkeditorLectureExerciseConfig() {
    return {
      font_names:
        'Century Schoolbook; Arial/Arial, Helvetica, sans-serif;Comic Sans MS/Comic Sans MS, ' +
        'cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;' +
        'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, ' +
        'sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, ' +
        'sans-serif;Verdana/Verdana, Geneva, sans-serif',
      defaultLanguage: 'ua',
      language: localStorage.getItem('language')
        ? localStorage.getItem('language')
        : 'ua',
      mathJaxLib:
        'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
      mathJaxClass: 'ckeditor-formulas',
      extraPlugins:
        'uploadimage,image2,mathjax,html5video,html5audio,stylescombo,youtube,imagesfromword,textindent,ckeditor_wiris',
      extraAllowedContent:
        this.getMathElements().join(' ') +
        '(*)[*]{*};img[data-mathml,data-custom-editor,role](Wirisformula)',
      height: 'calc(50vh - 185px)',
      youtube_width: '640',
      youtube_height: '480',
      youtube_responsive: false,
      youtube_related: true,
      youtube_privacy: false,
      youtube_autoplay: false,
      youtube_controls: true,
      youtube_disabled_fields: ['txtEmbed', 'chkAutoplay'],
      uploadUrl: env.api_url + 'ckeditor_image_upload/?lang=ru&format=json',
      filebrowserUploadUrl:
      env.api_url + 'ckeditor_image_upload/?lang=ru&format=json',
      toolbar: [
        {
          name: 'clipboard',
          items: ['Undo', 'Redo', 'Cut', 'Copy', 'Paste', 'PasteText'],
        },
        {
          name: 'ckeditor_wiris',
          items: [
            'ckeditor_wiris_formulaEditor',
            'ckeditor_wiris_formulaEditorChemistry',
          ],
        },
        {
          name: 'math',
          items: ['Mathjax', 'Table', 'HorizontalRule', 'SpecialChar'],
        },
        {
          name: 'link',
          items: ['Link', 'Unlink', 'Image', 'Html5video', 'Html5audio', 'Youtube', 'Iframe'],
        },
        {
          name: 'basicstyles',
          items: [
            'Styles', 'CreateDiv', 'Font', 'FontSize', 'RemoveFormat', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'
          ],
        },
        {
          name: 'color',
          items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'TextColor', 'BGColor'],
        },
        {
          name: 'paragraph',
          items: [
            'NumberedList', 'BulletedList', 'PageBreak', 'BidiLtr', 'BidiRtl'
          ],
        },
        {
          name: 'others',
          items: ['Maximize', 'Source', 'ShowBlocks'],
        },
      ],
    };
  },
  getCkeditorMissingWordsQuestionConfig() {
    return {
      font_names:
        'Century Schoolbook; Arial/Arial, Helvetica, sans-serif;Comic Sans MS/Comic Sans MS, ' +
        'cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;' +
        'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, ' +
        'sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, ' +
        'sans-serif;Verdana/Verdana, Geneva, sans-serif',
      defaultLanguage: 'ua',
      language: localStorage.getItem('language')
        ? localStorage.getItem('language')
        : 'ua',
      mathJaxLib:
        'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
      mathJaxClass: 'ckeditor-formulas',
      extraPlugins:
        'uploadimage,image2,mathjax,html5video,html5audio,youtube,imagesfromword,ckeditor_wiris,fakeobjects,dialog,dialogui,iframe',
      extraAllowedContent:
        this.getMathElements().join(' ') +
        '(*)[*]{*};img[data-mathml,data-custom-editor,role](Wirisformula)',
      height: 'calc(50vh - 225px)',
      youtube_width: '640',
      youtube_height: '480',
      youtube_responsive: false,
      youtube_related: true,
      youtube_privacy: false,
      youtube_autoplay: false,
      youtube_controls: true,
      youtube_disabled_fields: ['txtEmbed', 'chkAutoplay'],
      uploadUrl: env.api_url + 'ckeditor_image_upload/?lang=ru&format=json',
      filebrowserUploadUrl:
        env.api_url + 'ckeditor_image_upload/?lang=ru&format=json',
      toolbar: [
        {
          name: 'clipboard',
          items: ['Cut', 'Copy', '-', 'Undo', 'Redo'],
        },
        {
          name: 'ckeditor_wiris',
          items: [
            'ckeditor_wiris_formulaEditor',
            'ckeditor_wiris_formulaEditorChemistry',
          ],
        },
        {
          name: 'math',
          items: [
            'Mathjax',
            'Image',
            'Html5video',
            'Html5audio',
            'Table',
            'Youtube',
            'Iframe',
          ],
        },
        {
          name: 'link',
          items: [
            'Link',
            'Unlink',
            'Font',
            'FontSize',
            'Bold',
            'Italic',
            'Underline',
            'Strike',
            'Subscript',
            'Superscript',
            'SpecialChar',
            'TextColor',
            'BGColor',
          ],
        },
        {
          name: 'paragraph',
          items: [
            'NumberedList',
            'BulletedList',
            '-',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
            'PageBreak',
            'Maximize',
            'RemoveFormat',
            'Source',
          ],
        },
      ],
    };
  },

  removeFalsy(obj) {
      let newObj = {};

      Object.keys(obj).forEach((prop) => {
          if (obj[prop]) {
              newObj[prop] = obj[prop];
          }
      });

      return newObj;
  },

  getObjectDifference(defaultObj, compareObj) {
    const diff = {};

    Object.keys(defaultObj).forEach((key) => {
      if (compareObj[key] !== defaultObj[key]) {
        diff[key] = compareObj[key];
      }
    });

    return diff;
  },

  toFormData(obj) {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, val]) => formData.append(key, val));
    return formData;
  },

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },

  formatDateForBackend(dateObj) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const dateStr = dateObj.toLocaleDateString('en-GB', options);

    const [day, month, year] = dateStr.split('/');

    return `${year}-${month}-${day}`;
  },

  generateCsv(data) {
    const blob = new Blob(['\uFEFF' + data], {
      type: 'text/csv; charset=utf-18',
    });

    if (window.navigator.msSaveOrOpenBlob) {
      // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
      window.navigator.msSaveBlob(blob, 'export.csv');
    } else {
      const a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(blob, { type: 'text/plain' });
      a.download = 'export.csv';
      document.body.appendChild(a);
      a.click();
      // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
      document.body.removeChild(a);
    }
  },

  shuffleArray(array) {
    let currentIndex = array.length;
    let temporaryValue = undefined;
    let randomIndex = undefined;
  
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array;
  },

  getSmile(grade) {
    let link;

    switch (true) {
      case grade <= 3:
        link = '/assets/images/smile/smile-10.png';
        break;

      case grade >= 4 && grade <= 6:
        link = '/assets/images/smile/smile-3.png';
        break;

      case grade >= 7 && grade <= 9:
        link = '/assets/images/smile/smile-1.png';
        break;

      case grade >= 10:
        link = '/assets/images/smile/smile-11.png';
        break;
    
      default:
        link = '/assets/images/smile/smile-2.png';
        break;
    }

    return env.public_base + link;
  },

  getCredited(grade, isLongText = false) {
    let text;

    switch (true) {
      case grade <= 3:
        text = isLongText ? $t('credited_not') : $t('credited_not_short');
        break;

      case grade >= 4:
        text = isLongText ? $t('credited') : $t('credited_short');
        break;
    
      default:
        text = '--';
        break;
    }

    return text;
  },

  getCreditedIcon(grade) {
    let link;

    switch (true) {
      case grade <= 3:
        link = '/assets/images/cross-icon--red.svg';
        break;

      case grade >= 4:
        link = '/assets/images/check-icon--green.svg';
        break;
    
      default:
        link = '/assets/images/test-boolean-icon.svg';
        break;
    }

    return env.public_base + link;
  },
    
  sendSentryCaptureMessage(captureMessage, character) {
    Sentry.setContext("character", character);
    Sentry.captureMessage(captureMessage);
  },  
    
  prepareSentryMsg(rootState, addParams){
    const user = rootState.common.userData;
    const stateData = {
      user_id: user ? user.id : null,
      first_name: user ? user.first_name : null,
      last_name: user ? user.last_name : null,
      manifest: JSON.stringify(rootState.common.manifest),
      token_length: localStorage.getItem('token').length,  
    };
    
    const sentryMsgData = Object.assign({}, stateData, addParams);

    return sentryMsgData;
      
  },

  detectMobileDevice() {
    const mobileRegex1 = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;

    const mobileRegex2 = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
    
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
    return mobileRegex1.test(userAgent) || mobileRegex2.test(userAgent.substr(0,4));
  },
};
